import React from 'react';
import { Button } from '../../components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select';
import {
  Calendar as CalendarIcon,
  ChevronLeft,
  ChevronRight,
  MapPin,
  Building2,
} from 'lucide-react';
import { addMonths, subMonths } from 'date-fns';
import { MonthYearPicker } from '../../components/layout/MonthYearPicker';

export const CalendarHeader = ({
  filteredEmployees,
  branches,
  filterBranch,
  setFilterBranch,
  filterLocation,
  setFilterLocation,
  locations,
  currentDate,
  setCurrentDate,
}) => (
  <>
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div>
        <h1 className="font-heading font-bold text-xl sm:text-3xl text-foreground">Team-Kalender</h1>
        <p className="text-muted-foreground mt-1">
          {filteredEmployees.length} Mitarbeiter im Überblick
        </p>
      </div>
      <div className="flex flex-col sm:flex-row flex-wrap gap-2">
        {branches.length > 1 && (
          <Select value={filterBranch} onValueChange={(v) => { setFilterBranch(v); setFilterLocation('all'); }} data-testid="filter-branch">
            <SelectTrigger className="w-[200px]" data-testid="filter-branch-trigger">
              <Building2 className="mr-2 h-4 w-4 text-muted-foreground" />
              <SelectValue placeholder="Alle Niederlassungen" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Alle Niederlassungen</SelectItem>
              {branches.map(b => (
                <SelectItem key={b.id} value={b.id}>{b.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
        <Select value={filterLocation} onValueChange={setFilterLocation} data-testid="filter-location">
          <SelectTrigger className="w-[200px]" data-testid="filter-location-trigger">
            <MapPin className="mr-2 h-4 w-4 text-muted-foreground" />
            <SelectValue placeholder="Alle Standorte" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Alle Standorte</SelectItem>
            {locations
              .filter(l => filterBranch === 'all' || l.branch_id === filterBranch)
              .map(l => (
                <SelectItem key={l.id} value={l.id}>{l.name}</SelectItem>
              ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  </>
);

export const CalendarMonthNav = ({ currentDate, setCurrentDate }) => (
  <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
    <div className="flex items-center gap-1">
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8"
        onClick={() => setCurrentDate(subMonths(currentDate, 1))}
        data-testid="prev-month-btn"
        title="Vorheriger Monat (←)"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <CalendarIcon className="h-5 w-5 text-primary hidden sm:block" />
      <MonthYearPicker currentDate={currentDate} onChange={setCurrentDate} />
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8"
        onClick={() => setCurrentDate(addMonths(currentDate, 1))}
        data-testid="next-month-btn"
        title="Nächster Monat (→)"
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
    <div className="flex items-center gap-2">
      <span className="hidden md:inline text-xs text-muted-foreground" title="Tastatur-Shortcuts">
        <kbd className="px-1.5 py-0.5 text-[10px] font-mono bg-muted rounded border">←</kbd>
        <kbd className="px-1.5 py-0.5 text-[10px] font-mono bg-muted rounded border ml-1">→</kbd>
        <span className="ml-1">Monat</span>
        <kbd className="px-1.5 py-0.5 text-[10px] font-mono bg-muted rounded border ml-2">Pos1</kbd>
        <span className="ml-1">Heute</span>
      </span>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setCurrentDate(new Date())}
        className="rounded-full"
        data-testid="today-btn"
        title="Heute (Pos1)"
      >
        Heute
      </Button>
    </div>
  </div>
);
